export const IMG = {
  hero: "https://images.pexels.com/photos/39151698/pexels-photo-39151698.jpeg?auto=compress&cs=tinysrgb&w=1800",
  addition: "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  renovation: "https://images.unsplash.com/photo-1613544723301-176686aa9f09?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  concrete: "https://images.unsplash.com/photo-1660502316360-327f4741d887?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  commercial: "https://images.unsplash.com/photo-1603779931001-a6b508e5da81?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  blueprint: "https://images.unsplash.com/photo-1721244654394-36a7bc2da288?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  mountains: "https://images.pexels.com/photos/30255750/pexels-photo-30255750.jpeg?auto=compress&cs=tinysrgb&w=1800",
  tradesperson: "https://images.unsplash.com/photo-1621905252472-943afaa20e20?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};
